export default {
  data() {
    return {
      themeClass: 'theme-light'
    }
  },
  computed: {
    isThemeDark() {
      return this.themeClass == 'theme-dark'
    },
    isThemeLight() {
      return !this.isThemeDark
    }
  },
  methods: {
    setThemeClass(className) {
      this.toggleBodyClass('addClass', className)
      this.toggleBodyClass('removeClass', this.$data.themeClass)

      this.$data.themeClass = className
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
  
      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    }
  },
  mounted() {
    this.toggleBodyClass('addClass', this.$data.themeClass);
  },
  destroyed() {
    this.toggleBodyClass('removeClass', this.$data.themeClass);
  }
}